import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

import { userScopeCleared } from '@krp/client-runtime'

import type { ScanEventKind, ScanSessionState } from './types'

/** Сколько событий держит лента: смена поставки длинная, но лента — не журнал. */
export const SCAN_LOG_LIMIT = 50

const initialState: ScanSessionState = { created: 0, attached: 0, found: 0, skipped: 0, nextId: 1, log: [] }

export interface ScanEventPayload {
  kind: ScanEventKind
  text: string
  productId: string | null
  at: number
}

/**
 * Смена сканирования: четыре счётчика и лента. Срок жизни — `screen`: после F5 и закрытия сканера начинается новая смена
 * (`scanSessionStarted`). «Не сохранено» в счётчики не входит: сбой — не успех, он виден строкой ленты.
 */
const scanSessionSlice = createSlice({
  name: 'platform/scanSession',
  initialState,
  reducers: {
    scanSessionStarted() {
      return initialState
    },
    scanEventRecorded(state, action: PayloadAction<ScanEventPayload>) {
      const { kind, text, productId, at } = action.payload
      if (kind === 'created') state.created += 1
      else if (kind === 'attached') state.attached += 1
      else if (kind === 'found') state.found += 1
      else if (kind === 'skipped') state.skipped += 1
      state.log.unshift({ id: state.nextId, kind, text, at, productId })
      state.nextId += 1
      if (state.log.length > SCAN_LOG_LIMIT) state.log.length = SCAN_LOG_LIMIT
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userScopeCleared, () => initialState)
  },
})

export const { scanSessionStarted, scanEventRecorded } = scanSessionSlice.actions
export const scanSessionReducer = scanSessionSlice.reducer
